
import { AgsUser } from './AgsUser';

export class PagedAgsUserList {
    
    
    pageNo;
    isLastPage;
    
    index;
    
    users;
    
    //Construct from the backend Json Response
    constructor(json) {
        if (json) {
            this.isLastPage = json.last; 
            this.pageNo = json.pageNo; 
            this.index = json.index;
            
            if (json.items)
                this.users = json.items.map(u => new AgsUser(u));
            else
                this.users = [];
            
        }  
    } 
    
    isFirst = () => {
        return this.pageNo === 0;
    }
    
    isLast = () => {
        return this.isLastPage;
    }
    
}